import React from "react"
import AboutCard from "../About/AboutCard"

const About = () => {
  return (
    <>
      <section className='homeabout'>
        <div className='container top'>
          <AboutCard />
        </div>
      </section>
    </>
  )
}

export default About
